module.exports = __webpack_public_path__ + "static/img/bg35.f424cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg35.png
// module id = s3Gw
// module chunks = 28